import React from 'react';

function Dashboard() {
  return (
    <div>
      <h1>Welcome to Neuracraft Dashboard</h1>
      <p>You are now logged in successfully!</p>
    </div>
  );
}

export default Dashboard;
